import React from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'

import SEO from '../components/seo'
import {seo} from '../components/data/seo'

import Layout from "../components/organisms/Layout"
import TopContainer from '../components/molecules/TopContainer'
import BlogCategoryMenu from '../components/molecules/BlogCategoryMenu'
import BlogListContainer from '../components/molecules/BlogListContainer'

export const data = graphql`
  query {
    allMdx(sort: {fields: frontmatter___date, order: DESC} ,filter: {frontmatter: {type: {eq: "blog"}, show: {eq: "show"}}}) {
      nodes {
        frontmatter {
          title
          date
          type
          category_large
          category_small
          author
          featuredImage {
            childImageSharp {
              fluid {
                src
              }
            }
          }
        }
        fields {
          slug
          slug_path
        }
      }
    }
  }
`

export default ({data: {allMdx: {nodes}}, location}) => {
  return (
    <Layout location={location}>
      <SEO title={seo.blogs.title} description={seo.blogs.description} lang="en"/>
      <TopContainer title="Blogs" />
      <MainContainer>
        <BlogCategoryMenu/>
        <BlogListContainer nodes={nodes}/>
      </MainContainer>
    </Layout>
  )
}

const MainContainer = styled.div`
  width: 100%;
  height: auto;
  background-color: ${props => props.theme.beige};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media(min-width: 900px) {
    flex-direction: row;
    background-color: transparent;
    width: 80%;
    margin: 0 auto;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    top: -10rem;
  }
`